export interface ModalEntry {
	type?: string;
	[key: string]: unknown;
}

/**
 * Compute the next modal stack for the conductor.
 *
 * - `closeOtherModals` replaces the whole stack with just `data`.
 * - When `singletonType` is given and BOTH the incoming modal and the current
 *   top are that type, the top is replaced in place instead of a second one
 *   being pushed — so re-opening a singleton modal (e.g. a refined AI report
 *   intent carrying a new `draftId`/definition) updates the already-open modal
 *   rather than stacking a duplicate on top of it.
 * - Otherwise `data` is pushed.
 *
 * Pure and non-mutating: returns a new array, never touches `current`.
 */
export function nextModalStack(
	current: ModalEntry[],
	data: ModalEntry,
	closeOtherModals = false,
	singletonType?: string
): ModalEntry[] {
	if (closeOtherModals) {
		return [data];
	}
	const top = current.length > 0 ? current[current.length - 1] : undefined;
	if (singletonType && data && data.type === singletonType && top && top.type === singletonType) {
		return [...current.slice(0, -1), data];
	}
	return [...current, data];
}
